export const SHARED_CONSTANTS = {
  CANCEL: 'Cancel',
  COMPANY: 'COMPANY',
  BUILD: 'BUILD',
  CONFIRM: 'Confirm',
  DASHBOARD: 'Dashboard',
  WIDGET_STUDIO: 'Widget Studio',
  FUNCTION_STUDIO: 'Function Studio',
  DATA_STUDIO: 'Data Studio',
  SOLUTIONS: 'Solutions',
  CONNECTIONS: 'Connections',
  AGENT_SPEND: 'Sterling Spend',
  AGENT_DASHBOARD: 'Sterling Dashboard',
  BILLING: 'Billing',
  DETAILS: 'Details',
  HEY: 'Hey',
  LOGOUT: 'Logout',
  PAYMENT: 'Payment',
  PERSONAL: 'PERSONAL',
  PREFERENCES: 'PREFERENCES',
  PROFILE: 'Profile',
  ORGANISATIONS: 'Organisations',
  PROJECTS: 'Projects',
  SECURITY: 'Security',
  SETTINGS: 'Settings',
  SUPPORT: 'Support',
  TEAM_MEMBERS: 'Team members',
  FIGMA: 'Figma',
  TEMPLATE_EDITOR: 'Template editor',
  TERMS_AND_CONDITION: 'Terms and conditions',
  USERS: 'Users',
} as const;
